import { endpoint } from 'services/Api';

/**
 * Resource Endpoint.
 *
 * @type {String}
 */
const RESOURCE = 'generated-documents';

/**
 * Generated Document Resource Endpoints:
 *     - Load
 *     - Save
 *     - Create
 *     - Delete
 */
export default {
    /**
     * Load a Generated Document from the Server by Claim ID.
     *
     * @param  {int} claimId
     * @param  {int} page
     * @param  {object} filter
     *
     * @return {Promise}
     */
    load: (claimId, page, filter) => endpoint(RESOURCE, 'load', { claim_id: claimId, page, filter }),
    /**
     * Save an Edited Document to the Server.
     *
     * @param  {Object} document
     *
     * @return {Promise}
     */
    save: document => endpoint(RESOURCE, 'save', { document }),
    /**
     * Create a new Document.
     *
     * @param  {string} type
     * @param  {int} claimId
     * @param  {string} claimType
     * @param  {string} discountRate
     *
     * @return {Promise}
     */
    create: (type, claimId, claimType, discountRate) => endpoint(RESOURCE, 'create', {
        claim_id: claimId,
        claim_type: claimType,
        type,
        discount_rate: discountRate
    }),
    /**
     * Delete a Document.
     *
     * @param  {Object} document
     *
     * @return {Promise}
     */
    delete: document => endpoint(RESOURCE, 'delete', { document_id: document.id }),
    /**
     * Fetch moveable heads of loss.
     *
     * @param  {int} claimId
     * @param  {string} discountRate
     *
     * @return {Promise}
     */
    headsOfLoss: (claimId, discountRate) => endpoint(RESOURCE, 'fetchHeadsOfLoss', {
        claim_id: claimId,
        discount_rate: discountRate
    }),
};



// WEBPACK FOOTER //
// ./src/services/api/generatedDocuments.js